module.exports = __webpack_public_path__ + "GG.png?4ab8b43656349d279dd7bdfca07cc5bb";